import { render } from "./GeneralDatatablePlanTreatmentActions.vue?vue&type=template&id=7454ff25&scoped=true"
import script from "./GeneralDatatablePlanTreatmentActions.vue?vue&type=script&lang=js"
export * from "./GeneralDatatablePlanTreatmentActions.vue?vue&type=script&lang=js"

import "./GeneralDatatablePlanTreatmentActions.vue?vue&type=style&index=0&id=7454ff25&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7454ff25"]])

export default __exports__